import { render } from "./ViewOrganizationGeneralInformation.vue?vue&type=template&id=440f5057&scoped=true"
import script from "./ViewOrganizationGeneralInformation.vue?vue&type=script&lang=js"
export * from "./ViewOrganizationGeneralInformation.vue?vue&type=script&lang=js"

import "./general-info.scss?vue&type=style&index=0&id=440f5057&lang=scss&scoped=true"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-440f5057"]])

export default __exports__